export default __webpack_public_path__ + "static/media/LoginPageIcon.c1e6c252.png";